interface CategoryHeaderProps {
  name: string;
  intro: string;
  image: string;
  imageAlt: string;
  count: number;
}

export default function CategoryHeader({ name, intro, image, imageAlt, count }: CategoryHeaderProps) {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={image}
          alt={imageAlt}
          title={`${name} - 诱惑吃瓜`}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/55" />
      </div>

      <div className="relative mx-auto max-w-[1240px] px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-wrap items-center gap-3 text-xs text-accent-300">
          <span className="flex items-center gap-1.5 rounded-full border border-accent-400/50 px-3 py-1 tracking-widest">
            <i className="ri-bookmark-3-line text-sm" aria-hidden="true"></i>
            专栏
          </span>
          <span className="text-background-200/80">共 {count} 篇内容</span>
        </div>
        <h1 className="mt-4 font-heading text-3xl font-black tracking-wide text-background-50 md:text-5xl">
          {name}
        </h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200/85 md:text-base">
          {intro}
        </p>
      </div>
    </section>
  );
}